module.exports = __webpack_public_path__ + "media/images/icons/plus-f9448e89f60d4460b894b298c35844d2.svg";